import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { useReducer, useRef } from "react";
import { TabPanel, a11yProps } from '../../ui';
import { Button, Stack } from '@mui/material';
import UploadIcon from '@mui/icons-material/Upload';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ManageEmployee from '../ManageEmployee';
import ManageRole from '../ManageRole';
import RolePermissions from '../RolePermissions';
import { SecurityService } from '../../../service/securityService';
import { toast } from 'react-toastify';
import { useCan } from '../../../hooks/useCan';

const ValidTabEnum = {
    SELECT_TAB: "Select an item",
    VALID_ROLES: 'Role',
    EMPLOYEE: 'Employee',
    PERMISSIONS: 'Access Rights',
}

export default function ValidSecurity() {
    const can = useCan();
    const fileInputRef = useRef(null);
    
    const [state, updateState] = useReducer((state, params) => {
        return { ...state, ...params };
    }, {
        selectedItem: 0,
        exporting: false,
        importing: false,
    });

    const handleTabChange = (event, newValue) => {
        updateState({
            selectedItem: newValue
        });
    }

    const handleExport = async () => {
        // Check if user has permission to export
        if (!can.section('security', { action: 'manage-roles' })) {
            toast.error('You do not have permission to export roles and permissions');
            return;
        }

        try {
            updateState({ exporting: true });
            await SecurityService.exportRolesAndPermissions();
            toast.success('Roles and permissions exported successfully');
        } catch (error) {
            console.error('Export failed:', error);
            toast.error('Failed to export roles and permissions');
        } finally {
            updateState({ exporting: false });
        }
    };

    const handleImportClick = () => {
        // Check if user has permission to import
        if (!can.section('security', { action: 'manage-roles' })) {
            toast.error('You do not have permission to import roles and permissions');
            return;
        }
        fileInputRef.current?.click();
    };

    const handleFileChange = async (event) => {
        const file = event.target.files?.[0];
        if (!file) return;

        // Validate file type
        if (file.type !== 'application/json' && !file.name.endsWith('.json')) {
            toast.error('Please select a valid JSON file');
            return;
        }

        try {
            updateState({ importing: true });
            await SecurityService.importRolesAndPermissions(file);
            toast.success('Roles and permissions imported successfully');
            // Optionally refresh the data here
        } catch (error) {
            console.error('Import failed:', error);
            toast.error('Failed to import roles and permissions');
        } finally {
            updateState({ importing: false });
            // Reset file input
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
        }
    };

    return (
        <Box display={'flex'} flexDirection={'column'}>
            {/* <input
                ref={fileInputRef}
                type="file"
                accept=".json,application/json"
                style={{ display: 'none' }}
                onChange={handleFileChange}
            /> */}
            {/* <Stack direction={'row'} justifyContent={'flex-end'} spacing={1} mb={2}>
                <Button 
                    variant='outlined' 
                    startIcon={<UploadIcon />}
                    onClick={handleImportClick}
                    disabled={state.importing || !can.section('security', { action: 'manage-roles' })}
                >
                    {state.importing ? 'Importing...' : 'Import'}
                </Button>
                <Button 
                    variant='outlined' 
                    startIcon={<FileDownloadIcon />}
                    onClick={handleExport}
                    disabled={state.exporting || !can.section('security', { action: 'manage-roles' })}
                >
                    {state.exporting ? 'Exporting...' : 'Export'}
                </Button>
            </Stack> */}

                <Tabs
                    orientation="horizontal"
                    variant="scrollable"
                    value={state.selectedItem}
                    onChange={handleTabChange}
                    aria-label="Valid data"
                    sx={{ borderRight: 1, borderColor: 'divider' }}
                >
                    <Tab label={ValidTabEnum.VALID_ROLES} {...a11yProps(0)} />
                    <Tab label={ValidTabEnum.EMPLOYEE} {...a11yProps(1)} />
                    <Tab label={ValidTabEnum.PERMISSIONS} {...a11yProps(2)} />
                </Tabs>
                <Box sx={{ width: '100%' }}>
                    <TabPanel value={state.selectedItem} index={0}>
                        <ManageRole />
                    </TabPanel>
                    <TabPanel value={state.selectedItem} index={1}>
                        <ManageEmployee />
                    </TabPanel>
                    <TabPanel value={state.selectedItem} index={2}>
                        <RolePermissions />
                    </TabPanel>
                </Box>

        </Box>

    );
}